<style>
</style>

<template>
  <v-container fluid id="customer--view">
    <v-row class="secondary">
      <v-container fluid>
        <v-tabs slot="extension" v-model="selected" dark centered center-active show-arrows
                background-color="transparent" color="primary">
          <v-tabs-slider></v-tabs-slider>
          <v-tab v-for="(item, index) in items" :key="index" dark
                 :class="[ index === selected ? 'primary--text' : 'grey--text' ]">{{ $t(item) }}
          </v-tab>
        </v-tabs>
      </v-container>
    </v-row>
    <v-row>
      <v-col class="pa-0">
        <v-tabs-items v-model="selected">
          <v-tab-item summary>
            <my-summary :visits="customerData.visits" :charges="customerData.charges" :orders="customerData.orders"
                        :reservations="customerData.reservations" :documents="customerData.documents"></my-summary>
          </v-tab-item>
          <v-tab-item orders>
            <my-orders :orders="customerData.orders"></my-orders>
          </v-tab-item>
          <v-tab-item reservations>
            <my-reservations :reservations="customerData.reservations">
            </my-reservations>
          </v-tab-item>
          <v-tab-item visits>
            <my-visits :visits="customerData.visits">
            </my-visits>
          </v-tab-item>
          <v-tab-item documents>
            <my-documents :documents="customerData.documents">
            </my-documents>
          </v-tab-item>
          <v-tab-item cards>
            <my-cards :cards="customerData.cards">
            </my-cards>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
    import MyDocuments from '@/components/my-documents.vue'
    import MyOrders from '@/components/my-orders.vue'
    import MyCards from '@/components/my-cards.vue'
    import MyVisits from '@/components/my-visits.vue'
    import MyReservations from '@/components/my-reservations.vue'
    import MySummary from '@/components/my-summary.vue'
    import CustomerMixin from '@/mixins/customer-mixin.js'

    export default {
        name: 'CustomerPage',
        mixins: [CustomerMixin],
        components: {
            'my-orders': MyOrders,
            'my-cards': MyCards,
            'my-visits': MyVisits,
            'my-reservations': MyReservations,
            'my-documents': MyDocuments,
            'my-summary': MySummary
        },
        data() {
            return {
                selected: null,
                items: ['summary', 'orders', 'reservations', 'visits', 'documents', 'cards']
            }
        },
        created() {
            if (!this.hasCustomer) {
                this.$router.push({
                    name: 'base'
                }).catch(console.log)
            }
        },
        mounted() {
            this.selected = this.items.indexOf(this.$route.query.selected ?
                this.$route.query.selected :
                (this.$oauth2.storage.hasValue('chip-cus-sel', this.institutionId, this.customerId) ? this.$oauth2.storage.getValue('chip-cus-sel', this.institutionId, this.customerId) : 'summary'))
        },
        beforeDestroy() {
            this.$oauth2.storage.setValue('chip-cus-sel', this.items[this.selected], this.institutionId, this.customerId)
        },
      computed: {
        query: {
          get() {
            return this.$route.query
          }
        },
      },
      watch: {
        query() {
          this.selected = this.items.indexOf(this.$route.query.selected)
        },
      }
    }
</script>
